export const MEDIA = "media"
export const ALBUM = "album"
export const COMMENT = "comment"
